export const dataUrlToBlob = async (dataUrl) => {
    const handle = await fetch(dataUrl);
    return handle.blob();
};
